import styled from 'styled-components';

export const YellowHorizontal = styled.hr`
  width: 30px;
  margin-bottom: 15px;
  margin-left: auto;
  margin-right: auto;
  border-width: 2px;
  border-style: solid;
  border-color: rgb(254, 185, 72);
  border-image: initial;
`;

export const YellowHorizontalHero = styled(YellowHorizontal)`
  margin-top: 40px;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    margin-top: 80px;
  }

  @media (min-width: ${props => props.theme.breakpoints.values.xl}px) {
    margin-top: 106px;
  }
`;
